import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../../../layout/Navbar";
import Footer from "../../../layout/Footer";
import HFKBricks from "../../../assets/Our Products/InsulationFiber Blanket/HFK-INSULATION-BRICKS.jpg";
import CFKBricks from "../../../assets/Our Products/InsulationFiber Blanket/CFK-INSULATION-BRICKS.png";
import CeramicFiberBlankets from "../../../assets/Our Products/InsulationFiber Blanket/CERAMIC-FIBER-BLANKETS.jpg";
import CeramicFiberModules from "../../../assets/Our Products/InsulationFiber Blanket/CERAMIC-FIBER-MODULES.jpg";
import CeramicFiberBoards from "../../../assets/Our Products/InsulationFiber Blanket/CERAMIC-FIBER-BOARDS.jpg";
import CalciumSilicateBoards from "../../../assets/Our Products/InsulationFiber Blanket/CALCIUM-SILICATE-BLOCKS.jpg";

const products = [
    {
        name: "HFK Insulation Bricks",
        image: HFKBricks,
        path: "/products/hfk-insulation-bricks"
    },
    {
        name: "CFK Insulation Bricks",
        image: CFKBricks,
        path: "/products/cfk-insulation-bricks"
    },
    {
        name: "Ceramic Fiber Blankets",
        image: CeramicFiberBlankets,
        path: "/products/ceramic-fiber-blankets"
    },
    {
        name: "Hysil Boards",
        image: CalciumSilicateBoards,
        path: "/products/hysil-boards"
    },
    {
        name: "Ceramic Fiber Boards",
        image: CeramicFiberBoards,
        path: "/products/ceramic-fiber-boards"
    },
    {
        name: "Ceramic Fiber Modules",
        image: CeramicFiberModules,
        path: "/products/ceramic-fiber-modules"
    },
];

const Insulation_Fiber_Blanket = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <Navbar />
            {/* Products Section */}
            <section className="py-12 sm:py-16 lg:py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-8 sm:mb-12">
                        INSULATION/FIBER <span className="text-orange-500">BLANKETS</span>
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
                        {products.map((product, index) => (
                            <div
                                key={index}
                                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-transform transform hover:-translate-y-2 overflow-hidden animate-fadeInUp"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="w-full h-56 flex items-center justify-center bg-white">
                                    <img
                                        src={product.image}
                                        alt={product.name}
                                        className="max-h-full max-w-full object-contain"
                                    />
                                </div>
                                <div className="p-6">
                                    <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-800 mb-4">
                                        {product.name}
                                    </h3>
                                    <Link 
                                        to={product.path}
                                        className="px-4 py-2 bg-gradient-to-r from-yellow-500 to-orange-500 text-white rounded-lg hover:from-yellow-600 hover:to-orange-600 transition-all">
                                        Learn More
                                    </Link>
                                </div>
                            </div>

                        ))}
                    </div>
                </div>
            </section>

            <style jsx>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .animate-fadeInUp {
                    animation: fadeInUp 0.8s ease-out forwards;
                    opacity: 0;
                }
            `}</style>
            <Footer />
        </div>
    );
};

export default Insulation_Fiber_Blanket;